// Plan copy (descriptions, feature lists) ported from the Icebreaker plans page.
// `id` matches the Skua plan unique_id; prices come from Skua at runtime.

export const MARKETPLACE_PLANS = [
  {
    _id: 1,
    id: 'community_monthly',
    fresh_work_title: 'Community',
    title: 'Community',
    price: { dollar_sign: '$', title: 'month', true: '0', false: '0' },
    yearly_charge: 'Charged now - $0/yr',
    description:
      'Free forever. Perfect for hobbyists and community projects. Includes basic features to launch your concept.',
    includes: ['No transaction fee', 'Community Support', 'Free Tradly Hosted Website'], //! deprecated
    features: [
      {
        title: 'Tradly Branding in website',
        info: '',
        link: '',
      },
    ],
    history_timeline: 3,
    link: '/workspace/plans',
    btn_title: 'Start Building For Free',
  },
  {
    _id: 2,
    id: '2025-superstarter',
    fresh_work_title: 'Basic',
    title: 'Basic',
    price: { dollar_sign: '$', title: 'month', true: '---', false: '---' },
    yearly_charge: 'Charged now - ---/yr',
    description:
      'Ideal for Small team. All Community features plus white-labeling (removes "Built with Tradly" badge).',
    includes: ['No transaction fee', 'Community Support'], //! deprecated
    features: [
      {
        title: 'No transaction fee',
        info: '',
        link: '',
      },
      {
        title: 'Free Tradly hosted website',
        info: '',
        link: '',
      },
      {
        title: 'Add your custom domain',
        info: '',
        link: '',
      },
      {
        title: 'Editor - 3 Day page history',
        info: '',
        link: '',
      },
    ],
    history_timeline: 3,
    link: '/workspace/plans',
    btn_title: 'Start 7 Days Trial',
  },
  {
    _id: 3,
    id: '2025-starter',
    fresh_work_title: 'Starter',
    title: 'Starter',
    price: { dollar_sign: '$', title: 'month', true: '---', false: '---' },
    yearly_charge: 'Charged now - ---/yr',
    description:
      'For startups validating their business idea. Includes all essentials for market testing and initial customer acquisition.',
    includes: [
      'No transaction fee',
      'Community + Livechat + Emails',
      'No Tradly Branding in website',
    ], //! deprecated
    features: [
      {
        title: 'No transaction fee',
        info: '',
        link: '',
      },
      {
        title: 'Unlimited Custom Attributes',
        info: '',
        link: '',
      },
      {
        title: '30 Day page history',
        info: '',
        link: '',
      },
      {
        title: 'Gated Subscription',
        info: 'Subscription charges for people to open accounts & submit listings',
        link: '',
      },
      {
        title: 'Social Logins',
        info: 'Signup/in via Google, Meta',
        link: '',
      },
      {
        title: 'Webhooks',
        info: 'To connect with Zapier & Make',
        link: '',
      },
    ],
    history_timeline: 30,
    link: '/workspace/plans',
    btn_title: ' Start 7 Days Trial',
  },
  {
    _id: 4,
    id: '2025-growth',
    fresh_work_title: 'Growth',
    title: 'Growth',
    price: { dollar_sign: '$', title: 'month', true: '---', false: '---' },
    yearly_charge: 'Charged now - ---/yr',
    description:
      ' For proven ideas on their growth Stage. Have custom needs and additional integrations to grow.',
    includes: [
      'No transaction fee',
      'Slack Private Channel',
      'Custom "From Emails"',
      'Additional Mini Tools & Integrations',
    ], //! deprecated
    features: [
      {
        title: 'No transaction fee',
        info: '',
        link: '',
      },
      {
        title: "Custom 'From Email'",
        info: '',
        link: '',
      },
      {
        title: 'Additional Mini Tools & Integrations',
        info: '',
        link: '',
      },
      {
        title: 'Personalised Onboarding calls*',
        info: '',
        link: '',
      },
      {
        title: '90 Day page history',
        info: '',
        link: '',
      },
      {
        title: 'Multi Currencies & Multi Languages',
        info: '',
        link: '',
      },

      {
        title: 'Role-based access control (RBAC)',
        info: '',
        link: '',
      },
      {
        title: 'Inbuilt Chat for Apps',
        info: 'Native in-app messaging for your users',
        link: '',
      },
    ],
    history_timeline: 90,
    link: '/workspace/plans',
    btn_title: ' Start 7 Days Trial',
    is_show_star: true,
  },

  {
    _id: 5,
    id: '2025-scale',
    fresh_work_title: 'Scale (previously business)',
    title: 'Scale',
    price: { dollar_sign: '$', title: 'month', true: '---', false: '---' },
    yearly_charge: 'Charged now - ---/yr',
    description:
      'Business who are in growth stage and looking to have be-spoke solution and other custom requirements.',
    includes: ['No transaction fee', 'Priority Support', 'Multiple Channels(App Support)', 'RBAC'], //! deprecated
    history_timeline: 'unlimited',
    link: '/workspace/plans',
    features: [
      {
        title: 'No transaction fee',
        info: '',
        link: '',
      },
      {
        title: 'Priority Support',
        info: '24 hour response time for non-critical',
        link: '/pricing/marketplace#support',
      },
      {
        title: 'Multiple Channels (App Support)',
        info: '',
        link: '',
      },

      {
        title: 'Single Sign-on (SSO)',
        info: '',
        link: '',
      },

      {
        title: 'Unlimited page history',
        info: '',
        link: '',
      },
      {
        title: 'In-built Chat for Apps',
        info: '',
        link: '',
      },
    ],
    btn_title: ' Start 7 Days Trial',
  },
]

export const INDIE_PLANS = [
  {
    _id: 1,
    id: 'indie-free',
    title: 'Free',
    price: { dollar_sign: '$', title: 'month', true: '0', false: '0' },
    description: 'Start for free. Launch your store, sell products, and explore the platform with no upfront cost.',
    features: [
      { title: 'Tradly hosted storefront', info: '', link: '' },
      { title: 'Up to 50 products', info: '', link: '' },
      { title: 'Community support', info: '', link: '' },
      { title: 'Basic analytics', info: '', link: '' },
    ],
    link: '/workspace/plans',
    btn_title: 'Start for free',
  },
  {
    _id: 2,
    id: 'go',
    title: 'Pro',
    price: { dollar_sign: '$', title: 'month', true: '4.08', false: '4.99' },
    description: 'Everything a growing store needs — remove branding, add your domain, and unlock more tools.',
    features: [
      { title: 'No Tradly branding', info: '', link: '' },
      { title: 'Custom domain', info: '', link: '' },
      { title: 'Unlimited products', info: '', link: '' },
      { title: 'Email campaigns', info: '', link: '' },
      { title: 'AI Recommendations', info: '', link: '' },
      { title: 'Ticket-based support', info: '', link: '' },
    ],
    link: '/workspace/plans',
    btn_title: 'Start 7-day trial',
    is_show_star: true,
  },
  {
    _id: 3,
    id: 'genius',
    title: 'Genius',
    price: { dollar_sign: '$', title: 'month', true: '8.25', false: '12.99' },
    description: 'Full AI stack, advanced marketing, and everything unlocked for stores serious about growth.',
    features: [
      { title: 'Everything in Pro', info: '', link: '' },
      { title: 'AI Agents (Shopping Assistant, etc.)', info: '', link: '' },
      { title: 'Natural language search', info: '', link: '' },
      { title: 'Advanced email automation', info: '', link: '' },
      { title: 'Unlimited recommendation requests', info: '', link: '' },
      { title: 'Ticket-based support', info: '', link: '' },
    ],
    link: '/workspace/plans',
    btn_title: 'Start 7-day trial',
  },
]
